import EventType from '../Constants/EventType';

const dispatchEvent = (
    eventTarget: EventTarget,
    eventType: EventType,
    detail: any = null
): void => {
    const event = new CustomEvent(eventType, {
        bubbles: true,
        cancelable: true,
        detail
    });

    eventTarget.dispatchEvent(event);
};

export default dispatchEvent;